<div class="Footer_bottom">
  <section>
    <div class="container-fluid">
      <div class="my-3 d-flex align-items-center">
        <span class="pointer" routerLink="/manage-user">
          <svg class="me-3" id="keyboard_backspace_black_24dp_3_" data-name="keyboard_backspace_black_24dp(3)"
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path id="Path_7892" data-name="Path 7892" d="M0,0H24V24H0Z" fill="none" />
            <path id="Path_7893" data-name="Path 7893" d="M21,11H6.83l3.58-3.59L9,6,3,12l6,6,1.41-1.41L6.83,13H21Z"
              fill="black" />
          </svg>
        </span>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item fs-18"><a class="text-decoration-none" routerLink="/manage-user"
                style="color: #949494;">Portal Management</a></li>
            <li class="breadcrumb-item fs-18"><a class="text-decoration-none text-dark fw-500">{{userId ? 'Edit User' : 'Add User' }}</a></li>
          </ol>
        </nav>
      </div>


      <form  [formGroup]="userForm">
        <div class="row">
          <div class="col-12">
            <div class="card border-0 mb-3 shadow-sm">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" class="example-full-width w-100 p-0 mb-1">
                      <mat-label>Name *</mat-label>
                      <input matInput type="text" formControlName="name" placeholder="Enter Name" [ngClass]="{'is-invalid':userForm.get('name')?.touched && userForm.get('name')?.invalid}" appAlphabatesOnly [readonly]="currentMode == 'view'">
                    </mat-form-field>
                    <span class="invalid-feedback" *ngIf="(userForm.get('name')?.touched  || userForm.get('name')?.dirty) && userForm.get('name')?.invalid">
                      Name is required *.
                   </span>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" class="example-full-width w-100 p-0 mb-1">
                      <mat-label>Email *</mat-label>
                      <input matInput type="email" formControlName="email" [ngClass]="{'is-invalid':userForm.get('email')?.touched && userForm.get('email')?.invalid}" placeholder="example@gmail.com" [readonly]="currentMode == 'view'">
                    </mat-form-field>
                    <mat-error class="invalid-feedback mx-3 mb-0" *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid">
                      <ng-container *ngIf="userForm.get('email')?.errors?.required">
                        Email is required *.
                      </ng-container>
                      <ng-container *ngIf="userForm.get('email')?.errors?.email && !userForm.get('email')?.errors?.required">
                        Please enter a valid email.
                      </ng-container>
                    </mat-error>
                  </div>
                  <div class="col-md-4" [ngStyle]="{'pointer-events': currentMode == 'view' ? 'none' : 'auto'}">
                    <mat-form-field appearance="outline" class="w-100 p-0 mb-1">
                      <mat-label>User Role *                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                </mat-label>
                      <mat-select
                        formControlName="userRole"
                        placeholder="Select User Role"
                        [ngClass]="{'is-invalid':userForm.get('userRole')?.touched && userForm.get('userRole')?.invalid}"
                        #userRole
                        (keydown)="preventKeyboardInput($event)"
                        [disabled]="userId ? true : false"
                      >
                        <ng-container *ngFor="let userRole of userRoles">
                          <mat-option *ngIf="userId || userRole?.id === ADMIN_ROLE" [value]="userRole">
                            {{userRole?.name}}
                          </mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                    <mat-error class="invalid-feedback" *ngIf="(userForm.get('userRole')?.touched  || userForm.get('userRole')?.dirty) && userForm.get('userRole')?.invalid">
                      User Role is required *.
                   </mat-error>
                  </div>

                  <div class="col-md-4" *ngIf="showCountryDropdown">
                    <mat-form-field appearance="outline" class="w-100 p-0 mb-1">
                      <mat-label>Country Name *</mat-label>
                      <mat-select formControlName="countryName" [ngClass]="{'is-invalid':userForm.get('countryName')?.touched && userForm.get('countryName')?.invalid}" (selectionChange)="countryChangeHandler($event)" >
                        <mat-select-trigger *ngIf="userForm?.value?.countryName">
                          <img [src]="userForm.value?.countryName?.country_icons " alt="Image" class="option-image">
                          <span>{{userForm.value?.countryName?.name}}</span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let country of countrys" [value]="country">
                          <img [src]="country?.country_icons" alt="Image" class="option-image">
                          {{country?.name}}
                        </mat-option>
                      </mat-select>

                    </mat-form-field>
                    <mat-error class="invalid-feedback" *ngIf="(userForm.get('countryName')?.touched  || userForm.get('countryName')?.dirty) && userForm.get('countryName')?.invalid">
                      Country Name is required *.
                   </mat-error>
                  </div>
                  <div class="col-md-4" *ngIf="userId && userForm.value.userRole?.id !== ADMIN_ROLE">
                    <mat-form-field appearance="outline" class="w-100 p-0 mb-1">
                      <mat-label>Sector Name *</mat-label>
                      <mat-select formControlName="sectorName" [ngClass]="{'is-invalid':userForm.get('sectorName')?.touched && userForm.get('sectorName')?.invalid}" (selectionChange)="sectorChangeHandler($event)" [disabled]="!sectorNames?.length">
                        <mat-option *ngFor="let sectorName of sectorNames" [value]="sectorName">
                          {{sectorName?.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error class="invalid-feedback" *ngIf="(userForm.get('sectorName')?.touched  || userForm.get('sectorName')?.dirty) && userForm.get('sectorName')?.invalid">
                      Sector Name is required *.
                   </mat-error>
                  </div>
                  <div class="col-md-4" *ngIf="userId && userForm.value.userRole?.id !== ADMIN_ROLE">
                    <mat-form-field appearance="outline" class="w-100 p-0 mb-1">
                      <mat-label>Msme Name *</mat-label>
                      <mat-select formControlName="msmeName" [ngClass]="{'is-invalid':userForm.get('msmeName')?.touched && userForm.get('msmeName')?.invalid}" [disabled]="!msmeNames?.length">
                        <mat-option *ngFor="let msmeName of msmeNames" [value]="msmeName">
                          {{msmeName?.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error class="invalid-feedback" *ngIf="(userForm.get('msmeName')?.touched  || userForm.get('msmeName')?.dirty) && userForm.get('msmeName')?.invalid">
                      Msme Name is required *.
                   </mat-error>
                  </div>
                  <div class="col-md-4" *ngIf="userId && userForm.value.userRole?.id !== ADMIN_ROLE">
                    <mat-form-field appearance="outline" class="example-full-width col-md-12 p-0 mb-1">
                      <mat-label>employeeCount *</mat-label>
                      <input matInput type="text" placeholder="Enter Employee Count" min="1" max="{{maxEmployeeCount}}" (blur)="onEmployeeCountBlur()" formControlName="employeeCount" [ngClass]="{'is-invalid':userForm.get('employeeCount')?.touched && userForm.get('employeeCount')?.invalid}" (keypress)="numberOnly($event)" [readonly]="currentMode == 'view'">
                    </mat-form-field>
                    <span class="invalid-feedback" *ngIf="(userForm.get('employeeCount')?.touched  || userForm.get('employeeCount')?.dirty) && userForm.get('employeeCount')?.invalid">
                      employeeCount is required *.
                   </span>
                  </div>


                  <div class="text-end">
                    <button *ngIf="!userId" class="btn create-btn rounded-pill text-white" (click)="createUser()" [disabled]="userForm.invalid">Create</button>
                    <button *ngIf="userId && currentMode != 'view'" type="submit" class="btn create-btn rounded-pill text-white" (click)="createUser()" [disabled]="userForm.invalid">Update</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

    </div>
  </section>
</div>